<template>
  <b-modal
    id="modal1"
    ref="modal"
    ok-title="検索"
    title="検索"
    hide-footer
    @hidden="hideSearchModal"
    size="xl"
  >
    <template #modal-header>
      <div class="w-100 d-flex align-items-center justify-content-between">
        <h2 class="ml-3 p-2" style="font-size: 20px; font-weight: bold;">登録者検索</h2>
        <p @click="hideModal" class="mr-3">
          <i class="fa fa-times fa-2x"></i>
        </p>
      </div>
    </template>
    <form ref="form" @submit.prevent="search">
      <div class="form-container" v-if="activeTab == 'tab1'">
        <div class="custom-form-block reg-form">
          <div class="form-group row align-items-end mt-4">
            <!-- 登録日 -->
            <div class="col-sm-4 d-flex align-items-end">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                登録 / 更新日
              </h3>
              <div>
                <div class="d-flex w-300">
                  <vuejs-datepicker
                    format="yyyy-MM-dd"
                    clear-button-icon="fa fa-times"
                    :disabled-dates="disableFunction"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    v-model="fromDateModel"
                    placeholder="From"
                    class="mr-2"
                  ></vuejs-datepicker>
                  <vuejs-datepicker
                    format="yyyy-MM-dd"
                    clear-button-icon="fa fa-times"
                    :disabled-dates="disableFunction"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    v-model="toDateModel"
                    placeholder="To"
                  ></vuejs-datepicker>
                </div>
                <div v-if="dateRangeError" class="date-error-message">
                  有効な値を入力してください
                </div>
              </div>
            </div>

            <!-- 年齢 -->
            <div class="col-sm-4 d-flex align-items-end">
              <h3 class="col-form-label mr-3" style="min-width: 50px;">年齢</h3>
              <div>
                <div class="d-flex align-items-end">
                  <div class="d-flex align-items-end mr-2">
                    <input
                      type="number"
                      class="form-control ageInc-field mr-1"
                      v-model="fromAgeModel"
                      min="0"
                      :class="{ 'is-invalid': errors.fromAgeModel.error }"
                      style="width: 80px;"
                    />
                    <span class="age-text">歳</span>
                  </div>
                  <div class="d-flex align-items-end">
                    <span class="age-text mr-2">〜</span>
                    <input
                      type="number"
                      class="form-control ageInc-field mr-1"
                      v-model="toAgeModel"
                      min="0"
                      :class="{ 'is-invalid': errors.toAgeModel.error }"
                      style="width: 80px;"
                    />
                    <span class="age-text">歳</span>
                  </div>
                </div>
                <div v-if="errors.fromAgeModel.error || errors.toAgeModel.error" class="date-error-message">
                  有効な値を入力してください
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row align-items-end mt-4">
            <!-- 年収 -->
            <div class="col-sm-4 d-flex align-items-end">
              <h3 class="col-form-label mr-2" style="min-width: 120px;">
                年収
              </h3>
              <div>
                <div class="d-flex align-items-end">
                  <div class="d-flex align-items-end mr-2 ml-2">
                    <input
                      type="number"
                      class="form-control ageInc-field mr-1"
                      v-model="fromIncomeModel"
                      min="0"
                      :class="{ 'is-invalid': errors.fromIncomeModel.error }"
                      style="width: 100px;"
                    />
                    <span class="age-text">万円</span>
                  </div>
                  <div class="d-flex align-items-end">
                    <span class="age-text mr-2">〜</span>
                    <input
                      type="number"
                      class="form-control ageInc-field mr-1"
                      v-model="toIncomeModel"
                      min="0"
                      :class="{ 'is-invalid': errors.toIncomeModel.error }"
                      style="width: 100px;"
                    />
                    <span class="age-text">万円</span>
                  </div>
                </div>
                <div v-if="errors.fromIncomeModel.error || errors.toIncomeModel.error" class="date-error-message">
                  有効な値を入力してください
                </div>
              </div>
            </div>

            <!-- 性別 -->
            <div class="col-sm-4 d-flex align-items-end" style="gap: 20px;">
              <h3 class="col-form-label mr-3" style="min-width: 50px;">性別</h3>
              <div class="form-check mr-3">
                <input
                  type="checkbox"
                  id="male"
                  value="男性"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="male" class="form-check-label">男性</label>
              </div>
              <div class="form-check mr-3">
                <input
                  type="checkbox"
                  id="female"
                  value="女性"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="female" class="form-check-label">女性</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="unspecified"
                  value="指定なし"
                  class="form-check-input"
                  v-model="genderModel"
                />
                <label for="unspecified" class="form-check-label"
                  >指定なし</label
                >
              </div>
            </div>
          </div>

          <div class="form-group row mb-2 mt-4">
            <div class="col-sm-12 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                学歴
              </h3>
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;"
              >
                <div
                  v-for="finalEducation in finalEducations"
                  :key="finalEducation.id"
                >
                  <input
                    type="checkbox"
                    :id="finalEducation.id"
                    :value="finalEducation.id"
                    class="form-check-input mr-1"
                    v-model="finalEducationModel"
                  />
                  <label :for="finalEducation.id" class="form-check-label">
                    {{ finalEducation.title }}
                  </label>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-10">

          </div> -->
          </div>

          <div class="form-group row mt-4">
            <div class="col-sm-12 d-flex align-items-center" style="gap: 18px">
              <h3 class="col-form-label mr-3" style="min-width: 120px">
                英語力
              </h3>
              <!-- <div class="col-sm-10 ml-3"> -->
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;"
              >
                <div
                  v-for="englishSkill in englishSkills"
                  style="max-width: 30% !important;"
                >
                  <input
                    type="checkbox"
                    :id="englishSkill.id"
                    :value="englishSkill.id"
                    class="form-check-input"
                    v-model="englishSkillModel"
                  />
                  <label :for="englishSkill.id" class="form-check-label">{{
                    englishSkill.title
                  }}</label>
                </div>
              </div>
              <!-- </div> -->
            </div>
          </div>

          <div class="form-group row mt-4">
            <div class="col-sm-12 d-flex align-items-end" style="gap: 15px">
              <h3 class="col-form-label" style="min-width: 120px">経由</h3>
              <!-- <div class="col-sm-9 ml-2"> -->
              <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  id="own"
                  value="own"
                  class="form-check-input"
                  v-model="companyModel"
                />
                <label for="own" class="form-check-label">自社HP経由登録</label>
              </div>
              <div class="form-check form-check-inline ml-4">
                <input
                  type="checkbox"
                  id="other"
                  value="other"
                  class="form-check-input"
                  v-model="companyModel"
                />
                <label for="other" class="form-check-label"
                  >他ルート経由登録</label
                >
              </div>
              <!-- </div> -->
            </div>
          </div>


          <div class="form-group row mt-4">
            <div class="col-sm-4 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">直近職種</h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleJobClassification('toggle')"
                  href="javascript:void(0)"
                  :class="hasJobsSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  {{ hasJobsSelected ? '選択中' : '+選択' }}
                </a>
                <!-- <h3>
              <a v-b-toggle="'jobClassification'" href="Javascript:void(0)">直近職種</a>
            </h3> -->
                <b-modal
                  modal-class="custom-inner-modal"
                  id="jobClassification"
                  ref="jobClassificationModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px;overflow-y:scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="main in occupations"
                        v-bind:key="main.id"
                      >
                        <input
                          type="checkbox"
                          :id="main.id"
                          :value="main.id"
                          class="form-check-input"
                          v-model="mainJobModel"
                          @click="
                            watchParentJobUncheck(
                              $event,
                              'label' + main.id,
                              main
                            )
                          "
                        />
                        <label
                          :id="'label' + main.id"
                          @click="setLabelClicked"
                          class="form-check-label job-label"
                          >{{ main.title }}</label
                        >
                        <div
                          class="row"
                          v-if="
                            isChecked(main.id) ||
                              isLabelClicked('label' + main.id)
                          "
                        >
                          <div
                            class="col-sm-4"
                            v-for="child in main.children"
                            v-bind:key="child._id"
                          >
                            <div class="form-check form-check-inline">
                              <input
                                type="checkbox"
                                :id="child._id"
                                :value="child._id"
                                class="form-check-input"
                                v-model="childJobModel"
                                @click="manuallyCheckJob($event, main)"
                              />
                              <label
                                :for="child._id"
                                class="form-check-label"
                                >{{ child.title }}</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      data-dismiss="modal"
                      @click="toggleJobClassification('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      id="download"
                      class="btn btn-sm btn-primary search"
                      @click="toggleJobClassification('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
            <div class="col-sm-4 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">居住地</h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleResidence('toggle')"
                  href="javascript:void(0)"
                  :class="hasResidenceSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  {{ hasResidenceSelected ? '選択中' : '+選択' }}
                </a>
                <b-modal
                  ref="residenceModal"
                  id="residence"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                >
                  <div class="row p-2">
                    <div
                      class="col-md-3"
                      v-for="residence in reversedResidences"
                      v-bind:key="residence.id"
                    >
                      <div class="form-check form-check-inline">
                        <input
                          type="checkbox"
                          :id="residence.id"
                          :value="residence.id"
                          class="form-check-input"
                          v-model="residenceModel"
                        />
                        <label :for="residence.id" class="form-check-label">{{
                          residence.title
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      data-dismiss="modal"
                      @click="toggleResidence('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      id="download"
                      class="btn btn-sm btn-primary search"
                      @click="toggleResidence('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>

          <div class="form-group row mt-4">
            <div class="col-sm-12 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label" style="min-width:120px">
                キーワード
              </h3>
              <div class="">
                <div class="d-flex form-row">
                  <!-- <label for="word1" class="col-xs-3 col-form-label">すべてを含む</label> -->
                  <div>
                    <input
                      type="text"
                      id="word1"
                      v-model="wordModel"
                      class="form-control big-query"
                      placeholder="複数キーワードの場合はスペース区切りで入力してください"
                      style="border: 1px solid #b3b3b3;width: 500px;padding:5px; background: #fff;"
                    />
                  </div>
                  <div class="search-options mt-4" style="margin-left: 50px;">
                    <label class="">
                      <input
                        type="radio"
                        v-model="currentSearchType"
                        value="andSearch"
                        name="searchType"
                      />
                      すべてを含む
                    </label>
                    <label class="ml-3">
                      <input
                        type="radio"
                        v-model="currentSearchType"
                        value="orSearch"
                        name="searchType"
                      />
                      いずれかを含む
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row align-items-end mt-4"
            style="grid-gap: 10px !important;"
          >
            <div class="col-sm-3 d-flex align-items-end" style="gap: 14px">
              <h3 class="col-form-label mb-0" style="min-width: 120px;">
                スカウト希望
              </h3>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="scouthope"
                  class="form-check-input"
                  v-model="scoutHopeModel"
                />
                <label for="scouthope" class="form-check-label"
                  >スカウト希望</label
                >
              </div>
            </div>

            <!-- スカウト希望日 -->
            <div class="col-sm-4 d-flex align-items-end">
              <h3 class="col-form-label mr-3" style="min-width: 120px;">
                スカウト希望日
              </h3>
              <div>
                <div class="d-flex w-250">
                  <vuejs-datepicker
                    format="yyyy-MM-dd"
                    clear-button-icon="fa fa-times"
                    :disabled-dates="disableFunction"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    v-model="scoutedAtFromDateModel"
                    placeholder="From"
                    class="mr-2"
                  ></vuejs-datepicker>
                  <vuejs-datepicker
                    format="yyyy-MM-dd"
                    clear-button-icon="fa fa-times"
                    :disabled-dates="disableFunction"
                    :clear-button="true"
                    :bootstrap-styling="true"
                    v-model="scoutedAtToDateModel"
                    placeholder="To"
                  ></vuejs-datepicker>
                </div>
              </div>
            </div>

            <!-- ブックマーク -->
            <div class="col-sm-4 d-flex align-items-end" style="gap: 14px">
              <h3 class="col-form-label mr-3 mb-0" style="min-width: 60px;">
                ラベル
              </h3>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="bookmarkonly"
                  class="form-check-input"
                  v-model="favoriteModel"
                />
                <label for="bookmarkonly" class="form-check-label"
                  >ブックマーク</label
                >
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  id="bookmarkonly"
                  class="form-check-input"
                  v-model="interviewModel"
                />
                <label for="interviewOnly" class="form-check-label"
                  >面接実施</label
                >
              </div>
            </div>
          </div>

          <div class="form-group row mt-4">
            <div class="col-sm-12 d-flex align-items-end" style="gap: 16px">
              <h3 class="col-form-label" style="min-width: 120px">
                ステータス
              </h3>
              <div
                class="d-flex flex-wrap"
                style="column-gap: 50px; row-gap: 10px;margin-left: -1px;"
              >
                <div
                  v-for="(status, index) in getClientStatus"
                  v-bind:key="index"
                >
                  <div class="form-check form-check-inline">
                    <input
                      type="checkbox"
                      :id="index"
                      :value="status"
                      class="form-check-input"
                      v-model="statusModel"
                    />
                    <label :for="index" class="form-check-label">{{
                      status
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row mt-4 mb-2">
            <div class="col-sm-4 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label" style="min-width: 120px;">
                確認依頼用リスト
              </h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleReviewList('toggle')"
                  href="javascript:void(0)"
                  :class="hasReviewListSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  {{ hasReviewListSelected ? '選択中' : '+選択' }}
                </a>
                <b-modal
                  modal-class="custom-inner-modal"
                  id="reviewListModal"
                  ref="reviewListModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px; overflow-y: scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="(list, index) in getAllReviewLists"
                        v-bind:key="index"
                      >
                        <div class="form-check form-check-inline">
                          <input
                            type="checkbox"
                            :id="list._id"
                            :value="list._id"
                            class="form-check-input"
                            v-model="allReviewListModel"
                          />
                          <label
                            :for="list._id"
                            class="form-check-label job-label"
                            >{{ list.title }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      @click="toggleReviewList('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      class="btn btn-sm btn-primary search"
                      @click="toggleReviewList('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>

            <div class="col-sm-4 d-flex align-items-end" style="gap: 18px">
              <h3 class="col-form-label mb-0" style="min-width: 120px;">
                申込イベント
              </h3>
              <div class="ml-2">
                <a
                  v-on:click="toggleEventList('toggle')"
                  href="javascript:void(0)"
                  :class="hasEventSelected ? 'job-selected-badge' : 'job-select-link'"
                >
                  {{ hasEventSelected ? '選択中' : '+選択' }}
                </a>
                <b-modal
                  modal-class="custom-inner-modal"
                  id="eventListModal"
                  ref="eventListModal"
                  hide-header
                  hide-footer
                  :no-close-on-esc="true"
                  :no-close-on-backdrop="true"
                  size="huge"
                >
                  <div
                    class="form-group row"
                    style="max-height: 500px; overflow-y: scroll"
                  >
                    <div class="col-md-12">
                      <div
                        class="pl-4"
                        v-for="event in events"
                        v-bind:key="event._id"
                      >
                        <div class="form-check form-check-inline">
                          <input
                            type="checkbox"
                            :id="event._id"
                            :value="event._id"
                            class="form-check-input"
                            v-model="eventModel"
                          />
                          <label
                            :for="event._id"
                            class="form-check-label job-label"
                            >{{ formatDate(event.event_date.from) }},
                            {{ event.event_name }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer custom-footer">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-danger sm-button"
                      @click="toggleEventList('cancel')"
                    >
                      キャンセル
                    </button>
                    <button
                      type="submit"
                      class="btn btn-sm btn-primary search"
                      @click="toggleEventList('submit')"
                    >
                      保存
                    </button>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <JobDescriptionList v-if="activeTab == 'tab2'" :searchByJd="searchByJd" /> -->
      <div class="modal-footer d-flex justify-content-end" style="gap: 50px">
        <button
          type="submit"
          id="download"
          class="btn btn-primary search-btn-block btn-teal-2"
        >
          検索する
        </button>
        <button
          type="button"
          class="btn search-btn-block btn-gray"
          @click="clearSearch"
        >
          条件クリア
        </button>
        <button
          type="button"
          class="btn search-btn-block btn-saved-search"
          @click="showTitleModal"
        >
          保存した検索条件
        </button>
      </div>
    </form>
    <SearchTemplateModal
      ref="searchTemplate"
      :templates="userTemplate"
      :fromHomePage="true"
      :isSubmitting="isSubmitting"
      @hidden="hideTemplateModal"
      @prepopulateForm="prepopulateModels"
    />
  </b-modal>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import mutations from '@/config/mutations';
import actions from '@/config/actions';
import datePicker from 'vue-bootstrap-datetimepicker';
import vuejsDatepicker from 'vuejs-datepicker';
import moment from 'moment';
import JobDescriptionList from '../jobDescription/JobDescriptionList.vue';
import SearchTemplateModal from './SearchTemplateModal.vue';
export default {
  name: 'SearchForm',
  components: { datePicker, vuejsDatepicker, JobDescriptionList, SearchTemplateModal },
  data() {
    return {
      disableFunction: {
        customPredictor(date) {
          if (date > new Date()) {
            return true;
          }
        },
      },
      activeTab: 'tab1',
      searchByJd: false,
      fromOptions: null,
      toOptions: null,

      childOccupations: [],
      fromDateModel: null,
      toDateModel: null,
      scoutedAtFromDateModel: null,
      scoutedAtToDateModel: null,

      residenceModel: [],

      wordModel: null,
      currentSearchType: null,
      wordOne: '',
      wordAll: '',
      genderModel: [],

      scoutHopeModel: false,
      favoriteModel: null,
      interviewModel: null,
      tempChildJobs: [],
      tempResidence: [],
      tempReviewList: [],
      tempEventlist: [],
      tempMainJobs: [],
      fromAgeModel: null,
      toAgeModel: null,
      fromIncomeModel: null,
      toIncomeModel: null,
      isSubmitting: false,
      // statusModel: [],
      errors: {
        fromAgeModel: {
          error: false,
          msg: '',
        },
        toAgeModel: {
          error: false,
          msg: '',
        },
        fromIncomeModel: {
          error: false,
          msg: '',
        },
        toIncomeModel: {
          error: false,
          msg: '',
        },
      },
      clickedLabels: [],
      mainClicked: [],
      isJobClassificationOpen: false,
      isResidenceOpen: false,
    };
  },
  watch: {
    showModal(val) {
      if (val) this.$refs.modal.show();
      this.$refs.modal.hide();
    },
    fromAgeModel(value) {
      const data = this.fromValidation(value, this.toAgeModel);
      const data1 = this.toValidation(this.toAgeModel, value);
      [this.errors.fromAgeModel.error, this.errors.fromAgeModel.msg] = data;
      [this.errors.toAgeModel.error, this.errors.toAgeModel.msg] = data1;
    },
    toAgeModel(value) {
      const data = this.toValidation(value, this.fromAgeModel);
      const data1 = this.fromValidation(this.fromAgeModel, value);
      [this.errors.toAgeModel.error, this.errors.toAgeModel.msg] = data;
      [this.errors.fromAgeModel.error, this.errors.fromAgeModel.msg] = data1;
    },
    fromIncomeModel(value) {
      const data = this.fromValidation(value, this.toIncomeModel);
      const data1 = this.toValidation(this.toIncomeModel, value);
      [
        this.errors.fromIncomeModel.error,
        this.errors.fromIncomeModel.msg,
      ] = data;
      [this.errors.toIncomeModel.error, this.errors.toIncomeModel.msg] = data1;
    },
    toIncomeModel(value) {
      const data = this.toValidation(value, this.fromIncomeModel);
      const data1 = this.fromValidation(this.fromIncomeModel, value);
      [this.errors.toIncomeModel.error, this.errors.toIncomeModel.msg] = data;
      [
        this.errors.fromIncomeModel.error,
        this.errors.fromIncomeModel.msg,
      ] = data1;
    },
    searchParams(value) {
      this.prepopulateModels();
      if (Object.keys(value).length === 0) {
        this.clearForm();
      }
    },

  },
  created() {
    this.load();
    this.prepopulateModels();
  },
  computed: {
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    finalEducationModel: {
      get() {
        return this.getFinalEducationModel;
      },
      set(value) {
        this.setFinalEducationModel(value);
      },
    },
    eventModel: {
      get() {
        return this.getEventModel;
      },
      set(value) {
        this.setEventModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    allReviewListModel: {
      get() {
        return this.getAllReviewListModel;
      },
      set(value) {
        this.setAllReviewListModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    resumeModel: {
      get() {
        return this.getResumeModel;
      },
      set(value) {
        this.setResumeModel(value);
      },
    },
    jobSummaryModel: {
      get() {
        return this.getJobSummaryModel;
      },
      set(value) {
        this.setJobSummaryModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    reversedResidences() {
      const newResidences = this.residences;
      return newResidences;
      // return newResidences.reverse();
    },
    hasJobsSelected() {
      return this.getMainJobModel.length > 0 || this.getChildJobModel.length > 0;
    },
    hasResidenceSelected() {
      return this.residenceModel.length > 0;
    },
    hasReviewListSelected() {
      return this.getAllReviewListModel.length > 0;
    },
    hasEventSelected() {
      return this.getEventModel.length > 0;
    },
    dateRangeError() {
      if (this.fromDateModel && this.toDateModel) {
        return new Date(this.fromDateModel) > new Date(this.toDateModel);
      }
      return false;
    },
    ...mapGetters({
      getActiveCategory: 'getActiveCategory',
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getFinalEducationModel: 'getFinalEducationModel',
      getResumeModel: 'getResumeModel',
      getJobSummaryModel: 'getJobSummaryModel',
      getStatusModel: 'getStatusModel',
      getClientStatus: 'getClientStatus',
      getCompanyModel: 'getCompanyModel',
      getColorModel: 'getColorModel',
      getEventModel: 'getEventModel',
      getEvents: 'getEvents',
      getAllReviewLists: 'getAllReviewLists',
      getAllReviewListModel: 'getAllReviewListModel',
      userTemplate: 'getCurrentUserSearchTemplate',
    }),
    ...mapState({
      showModal: ({ applicant }) => applicant.showSearchModal,
      residences: ({ applicant }) => applicant.selectors.residences || [],
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
      finalEducations: ({ applicant }) =>
        applicant.selectors.finalEducations || [],
      events: ({ applicant }) => applicant.events || [],
      searchParams: ({ applicant }) => applicant.searchParams,
      manuallyCheckedJobs: ({ applicant }) => applicant.manuallyCheckedJobs,
    }),
    form() {
      let main = [...this.getMainJobModel, ...new Set(this.mainClicked)];

      return {
        registrationDateFrom: this.fromDateModel
          ? moment(this.fromDateModel).format('YYYY-MM-DD')
          : null,
        registrationDateTo: this.toDateModel
          ? moment(this.toDateModel).format('YYYY-MM-DD')
          : null,
        ageFrom: this.fromAgeModel,
        ageTo: this.toAgeModel,
        englishSkills: this.englishSkillModel,
        finalEducations: this.finalEducationModel,
        resume: this.resumeModel,
        jobSummary: this.jobSummaryModel,
        events: this.eventModel,
        residences: this.residenceModel,
        incomeFrom: this.fromIncomeModel,
        incomeTo: this.toIncomeModel,
        word: this.wordModel,
        searchType: this.currentSearchType,
        favorites: this.favoriteModel,
        interviews: this.interviewModel,
        scoutHope: this.scoutHopeModel,
        scoutedAtFrom: this.scoutedAtFromDateModel
          ? moment(this.scoutedAtFromDateModel).format('YYYY-MM-DD')
          : null,
        scoutedAtTo: this.scoutedAtToDateModel
          ? moment(this.scoutedAtToDateModel).format('YYYY-MM-DD')
          : null,
        childOccupations: this.getChildJobModel,
        mainJobs: [...new Set(main)],
        status: this.statusModel,
        reviewLists: this.allReviewListModel,
        regcompany: this.companyModel,
        client_color: this.colorModel,
        gender: this.genderModel,
      };
    },
    checkError() {
      return (
        this.errors.fromAgeModel.error ||
        this.errors.toAgeModel.error ||
        this.errors.fromIncomeModel.error ||
        this.errors.toIncomeModel.error
      );
    },
  },
  methods: {
    ...mapMutations([
      mutations.applicant.TOGGLE_SEARCH_MODAL,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      mutations.applicant.SET_SELECTORS,
      mutations.applicant.SET_EVENTS,
      'setEventModel',
      'setBulkActiveCategory',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'setColorModel',
      'setManuallyCheckedJobs',
      'updateMainJobModel',
      'setAllReviewLists',
      'setAllReviewListModel',
      'setFinalEducationModel',
      'setResumeModel',
      'setJobSummaryModel',
    ]),
    ...mapActions([
      actions.applicant.LOAD_SELECTORS,
      actions.applicant.LOAD_EVENTS,
      actions.applicant.LOAD_ALL_REVIEWLIST,
    ]),
    showTitleModal() {
      this.$refs.searchTemplate.show();
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    handlejobSummaryChange(value) {
      this.jobSummaryModel = this.jobSummaryModel === value ? null : value;
    },
    handleResumeChange(value) {
      this.resumeModel = this.resumeModel === value ? null : value;
    },
    hideTemplateModal() {
      this.$refs.searchTemplate.hide();
    },
    hideModal() {
      this.isResidenceOpen = false;
      this.isJobClassificationOpen = false;
      this[mutations.applicant.TOGGLE_SEARCH_MODAL](false);
    },
    toggleJobClassification(action) {
      if (action === 'toggle') {
        this.tempChildJobs = this.childJobModel;
        this.tempMainJobs = this.mainJobModel;
        this.$refs.jobClassificationModal.show();
      } else if (action === 'cancel') {
        this.childJobModel = this.tempChildJobs;
        this.mainJobModel = this.tempMainJobs;
        this.$refs.jobClassificationModal.hide();
      } else if (action === 'submit') {
        this.$refs.jobClassificationModal.hide();
      }
    },
    toggleResidence(action) {
      if (action === 'toggle') {
        this.tempResidence = this.residenceModel;
        this.$refs.residenceModal.show();
      } else if (action === 'cancel') {
        this.residenceModel = this.tempResidence;
        this.$refs.residenceModal.hide();
      } else if (action === 'submit') {
        this.$refs.residenceModal.hide();
      }
    },
    toggleReviewList(action) {
      if (action === 'toggle') {
        this.tempReviewList = [...this.allReviewListModel];
        this.$refs.reviewListModal.show();
      } else if (action === 'cancel') {
        this.allReviewListModel = [...this.tempReviewList];
        this.$refs.reviewListModal.hide();
      } else if (action === 'submit') {
        this.$refs.reviewListModal.hide();
      }
    },
    toggleEventList(action) {
      if (action === 'toggle') {
        this.tempEventList = [...this.eventModel];
        this.$refs.eventListModal.show();
      } else if (action === 'cancel') {
        this.eventModel = [...this.tempEventList];
        this.$refs.eventListModal.hide();
      } else if (action === 'submit') {
        this.$refs.eventListModal.hide();
      }
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    formatDate(date) {
      return moment(date)
        .utc()
        .format('YYYY-MM-DD');
    },
    isLabelClicked(id) {
      return this.clickedLabels.indexOf(id) !== -1;
    },
    setLabelClicked(event) {
      let index = this.clickedLabels.indexOf(event.target.id);
      if (index !== -1) {
        this.clickedLabels.splice(index, 1);
      } else {
        this.clickedLabels.push(event.target.id);
      }
    },
    watchParentJobUncheck(event, id, main) {
      let index = this.clickedLabels.indexOf(id);
      let mainIndexId = id.replace('label', '');
      let mainIndex = this.mainClicked.indexOf(mainIndexId);
      mainIndex === -1 && this.mainClicked.push(main.id);
      if (event.target.checked) {
        main.children.forEach((child) => this.childJobModel.push(child._id));
      } else {
        if (index !== -1) {
          this.clickedLabels.splice(index, 1);
        }
        if (mainIndex !== -1) {
          let removed = this.mainClicked.filter((item) => item != mainIndexId);
          this.mainClicked = [...removed];
        }
        const main = this.occupations.find((occ) => mainIndexId === occ.id);
        main.children.forEach((child) => {
          const index = this.childJobModel.indexOf(child._id);
          if (index !== -1) {
            const newChildJobModel = [...this.childJobModel];
            const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];
            newChildJobModel.splice(index, 1);
            newManuallyCheckedJobs.splice(index, 1);
            // Update the state properties with the new arrays
            this.childJobModel = newChildJobModel;
            this.setManuallyCheckedJobs(newManuallyCheckedJobs);
            this.setManuallyCheckedJobs(
              Array.from(new Set(this.manuallyCheckedJobs))
            );
          }
        });
      }
      this.childJobModel = Array.from(new Set(this.childJobModel));
    },
    manuallyCheckJob(event, main) {
      if (event.target.checked) {
        this.manuallyCheckedJobs.push(event.target.id);
        this.childJobModel.push(event.target.id);
        !this.mainClicked.includes(main.id) && this.mainClicked.push(main.id);
      } else {
        let index = this.manuallyCheckedJobs.indexOf(event.target.id);
        let childIndex = this.childJobModel.indexOf(event.target.id);
        const newChildJobModel = [...this.childJobModel];
        newChildJobModel.splice(childIndex, 1);
        this.childJobModel = newChildJobModel;
        if (index !== -1) {
          const newManuallyCheckedJobs = [...this.manuallyCheckedJobs];

          newManuallyCheckedJobs.splice(index, 1);
          this.setManuallyCheckedJobs(newManuallyCheckedJobs);
        }
      }
      let x = this.checkChildCount(main);
      if (x.childCount < 1) {
        let mainJob = this.mainJobModel.indexOf(main.id);
        let mainIndex = this.mainClicked.indexOf(main.id);
        //   let clickedLabelIndex = this.clickedLabels.indexOf(`label${main.id}`);
        this.clickedLabels = this.clickedLabels.filter(
          (item) => item !== `label${main.id}`
        );
        this.mainClicked.splice(mainIndex, 1);
        // console.log(mainJob);
        if (mainJob !== -1) {
          this.mainJobModel.splice(mainJob, 1);
        }
      }
    },
    checkChildCount(main) {
      let children = main.children.length;
      let childCount = 0;
      for (let i = 0; i < main.children.length; i++) {
        for (let j = 0; j < this.childJobModel.length; j++) {
          // console.log('here');
          if (main.children[i]._id == this.childJobModel[j]) {
            childCount++;
          }
        }
      }
      let childCounts = {
        children,
        childCount,
      };
      return childCounts;
    },
    hideSearchModal() {
      this[mutations.applicant.TOGGLE_SEARCH_MODAL](false);
    },
    scrollToError() {
      const element = document.getElementsByClassName('invalid-feedback')[0];
      if (element) {
        const parent = element.closest('.col-lg-6');
        parent.scrollIntoView();
      }
    },
    search() {
      if (this.activeTab == 'tab2') {
        this.searchByJd = true;
        this.$store.commit('jd/setShouldTriggerSearch', true);
        this.$store.commit('setIsJdSearch', true);
        return;
      }
      if (!this.checkError) {
        const params = this.form;
        Object.keys(params).forEach(
          (key) => !params[key] && delete params[key]
        );
        this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
        this.hideSearchModal();
      } else {
        this.scrollToError();
      }
    },
    load() {
      this[actions.applicant.LOAD_SELECTORS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_SELECTORS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));

      this[actions.applicant.LOAD_EVENTS]()
        .then(({ data }) => {
          this[mutations.applicant.SET_EVENTS](data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));

      this[actions.applicant.LOAD_ALL_REVIEWLIST]()
        .then(({ data }) => {
          this.setAllReviewLists(data.data);
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
    fromValidation(valueModel, model) {
      let error = '';
      let msg = '';
      if (valueModel === '' || valueModel === null) {
        error = false;
        msg = '';
        return [error, msg];
      }
      if (model !== '' && model !== null) {
        if (valueModel < 0) {
          error = true;
          // msg = 'value cannot be less than 0.';
          msg = '入力データが正しくありません。';
          return [error, msg];
        }
        if (valueModel <= parseFloat(model)) {
          error = false;
          msg = '';
          return [error, msg];
        }
        if (model < 0) {
          error = false;
          msg = '';
          return [error, msg];
        }
        error = true;
        // msg = `value must be less or equals to ${model}.`;
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      if (valueModel < 0) {
        error = true;
        // msg = 'value cannot be less than 0.';
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      error = false;
      msg = '';
      return [error, msg];
    },
    toValidation(valueModel, model) {
      let error = '';
      let msg = '';
      if (valueModel === '' || valueModel === null) {
        error = false;
        msg = '';
        return [error, msg];
      }
      if (model !== '' && model !== null) {
        if (valueModel < 0) {
          error = true;
          // msg = 'value cannot be less than 0.';
          msg = '入力データが正しくありません。';
          return [error, msg];
        }
        if (valueModel >= parseFloat(model)) {
          error = false;
          msg = '';
          return [error, msg];
        }
        error = true;
        // msg = `value must be greater or equals to ${model}.`;
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      if (valueModel < 0) {
        error = true;
        // msg = 'value cannot be less than 0.';
        msg = '入力データが正しくありません。';
        return [error, msg];
      }
      error = false;
      msg = '';
      return [error, msg];
    },
    prepopulateModels(customSearchParams = null) {
      const searchData = customSearchParams || this.searchParams;
      
      // Define the mapping between searchParams and model properties
      const fieldMappings = {
        toIncomeModel: 'incomeTo',
        fromIncomeModel: 'incomeFrom',
        toAgeModel: 'ageTo',
        fromAgeModel: 'ageFrom',
        childJobModel: 'childOccupations',
        wordModel: 'word',
        currentSearchType: 'currentSearchType',
        favoriteModel: 'favorites',
        interviewModel: 'interviews',
        scoutHopeModel: 'scoutHope',
        residenceModel: 'residences',
        englishSkillModel: 'englishSkills',
        eventModel: 'events',
        toDateModel: 'registrationDateTo',
        fromDateModel: 'registrationDateFrom',
        scoutedAtFromDateModel: 'scoutedAtFrom',
        scoutedAtToDateModel: 'scoutedAtTo',
        statusModel: 'status',
        companyModel: 'regcompany',
        colorModel: 'client_color',
        allReviewListModel: 'reviewLists',
        finalEducationModel: 'finalEducations',
        resumeModel: 'resume',
        jobSummaryModel: 'jobSummary',
        genderModel: 'gender'
      };

      // Apply all mappings
      Object.entries(fieldMappings).forEach(([modelKey, searchKey]) => {
        if (searchData[searchKey]) {
          this[modelKey] = searchData[searchKey];
        }
      });

      // Handle mainJobs
      this.clickedLabels = [];

      searchData.mainJobs && searchData.mainJobs.forEach((item) => {
        this.clickedLabels.push('label' + item);
      });
      
      // Handle other special cases if needed
      // searchData.childOccupations && this.setManuallyCheckedJobs(searchData.childOccupations);
    },
    clearForm() {
      this.errors = {
        fromAgeModel: {
          error: false,
          msg: '',
        },
        toAgeModel: {
          error: false,
          msg: '',
        },
        fromIncomeModel: {
          error: false,
          msg: '',
        },
        toIncomeModel: {
          error: false,
          msg: '',
        },
        scoutedAtFromDateModel: {
          error: false,
          msg: '',
        },
        scoutedAtToDateModel: {
          error: false,
          msg: '',
        },
      };
      this.scoutedAtFromDateModel = null;
      this.scoutedAtToDateModel = null;
      this.toIncomeModel = null;
      this.fromIncomeModel = null;
      this.toAgeModel = null;
      this.fromAgeModel = null;
      this.tempMainJobs = [];
      this.tempChildJobs = [];
      this.childJobModel = [];
      this.mainJobModel = [];
      this.mainClicked = [];
      this.wordModel = null;
      this.currentSearchType = null;
      (this.scoutHopeModel = false),
        (this.favoriteModel = null),
        (this.interviewModel = null),
        (this.residenceModel = []);
      this.tempResidence = [];
      this.englishSkillModel = [];
      (this.eventModel = []), (this.toDateModel = null);
      this.fromDateModel = null;
      this.statusModel = [];
      this.companyModel = [];
      this.colorModel = [];
      this.setManuallyCheckedJobs([]);
      this.clickedLabels = [];
      this.allReviewListModel = [];
      this.jobSummaryModel = [];
      this.finalEducationModel = [];
      this.resumeModel = [];
      this.genderModel = [];
      this.searchByJd = false;
      this.activeTab = 'tab1';
    },
    clearSearch() {
      // Clear all search conditions
      this.clearForm();
    },
  },
};
</script>

<style scoped>
input[type=checkbox] {
  height: 16px;
  width: 16px;
}
.w-300 {
  width: 300px;
}
.w-250 {
  width: 250px;
}
.col-form-label {
  padding: 0px !important;
}
.btn-teal-2 {
  background-color: #006c6b !important;
  border-color: #006c6b !important;
}
.w-50 {
  width: 50%;
}
.text-center {
  text-align: center;
}
>>> .modal-header {
  padding: 1rem 0 0 0;
}

.nav-item.active-tab {
  color: #006c6b;
  font-weight: bold;
  border-bottom: 4px solid #006c6b;
}

.active-tab a {
  color: #006c6b;
}

a {
  color: #3c3c3c;
}

a:hover {
  color: #006c6b;
}


.form-group.row {
  grid-gap: 150px;
}

.sm-button {
  border: 1px solid red;
  color: red;
}
>>> .btn-sm {
  font-size: 12px;
  padding: 10px;
  border-radius: 5px;
}

>>> .form-group {
  margin-bottom: 0px;
}
>>> .form-group .col-sm-5 {
  padding: 0px;
}

>>> .form-group .col-sm-9 {
  padding: 0px;
}

>>> .custom-form-block .form-control.big-query {
  border-bottom: 1px solid #b3b3b3 !important;
}

>>> .custom-form-block .form-control {
  border-bottom: 1px solid #b3b3b3 !important;
}

>>> .custom-form-block input.form-control::placeholder {
  color: #b4b2b2 !important;
  font-size: 14px;
}

>>> .custom-form-block label {
  color: #3c3c3c !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

>>> .age-text {
  width: 40px;
  color: #3c3c3c;
  font-weight: 400;
}

.form-container {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 78vh;
}

>>> .reg-form {
  margin: auto;
  width: 75vw;
  /* overflow-y: scroll;
  overflow-x: hidden;
  max-height: 78vh; */
}

>>> .ageInc-field {
  width: 180px;
}

.reg-form h3,
.form-group h3 {
  text-transform: uppercase;
  color: #3c3c3c;
  font-weight: 600;
  font-size: 13px;
  padding: 0px;
  margin-bottom: 0px !important;
}

.reg-form h3 a,
.form-group h3 a {
  text-transform: uppercase;
  color: #3c3c3c;
  font-weight: 600;
  font-size: 13px;
}

>>> .reg-form #bigQuery {
  text-transform: uppercase;
  color: #2bb2ab !important ;
  font-weight: 600 !important;
  font-size: 13px !important;
  margin-left: 5px;
  margin-bottom: 8px;
  margin-top: 5px;
}

.reg-form h3 a:hover,
.reg-form h3 a:focus {
  color: #1b7c77;
}

.reg-form .form-check-inline {
  margin-bottom: 2px !important;
}

.reg-form .form-check-inline .form-check-input {
  margin-top: -2px;
}

.mb-20 {
  margin-bottom: 20px;
}
.modal-content {
  background-color: #fbfcff;
}
.modal-search .modal-title {
  font-size: 15px;
  font-weight: 600;
}

.modal-search .modal-header,
.modal-search .modal-footer {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.sub-head {
  color: #89969f;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 7px;
  padding-top: 10px;
}
.btn-rmv {
  background: transparent;
  padding-right: 15px;
  font-size: 20px;
  color: #31bab4;
  border: none;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
  cursor: pointer;
  z-index: 99;
}
/* .bnt-grp button */

/* job label */
.job-label font {
  pointer-events: none;
}

.job-label:hover {
  text-decoration: underline;
}

/* Job selection styling */
.job-select-link {
  color: #3c3c3c;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}

.job-selected-badge {
  color: #006C6B;
  background-color: transparent;
  border: 3px solid #006C6B;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
}

.job-selected-badge:hover {
  text-decoration: none;
  background-color: rgba(32, 178, 170, 0.1);
}

/* Date validation error styling */
.date-error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
}

/* Button styles */
.btn-gray {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: white !important;
}

.btn-gray:hover {
  background-color: #5a6268 !important;
  border-color: #5a6268 !important;
}

.btn-saved-search {
  background-color: #036AC9 !important;
  border-color: #036AC9 !important;
  color: white !important;
}

.btn-saved-search:hover {
  background-color: #025a9e !important;
  border-color: #025a9e !important;
}
</style>
